export const tryCatchSafe = (fn, errMsg = "Error in tryCatchSafe") => {
  try {
    fn();
  } catch (error) {
    console.log(errMsg, error);
  }
};
